var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { createRef } from "preact";
import style from "./style.module.scss";
export default function TextArea(props) {
    const { error, code = false } = props, textAreaProps = __rest(props, ["error", "code"]);
    const textAreaRef = createRef();
    const errorClass = error ? style["text-area--error"] : "";
    const codeClass = code ? style["text-area--code"] : "";
    const codeHelpClass = code ? style["code-help--visible"] : "";
    //If in code mode we add a hint under the text area letting user know that they can use Command + M to insert a tab and Shit + Command + M to remove a tab.
    function keyDownUpdate(event) {
        if (textAreaRef.current && event.ctrlKey && event.key === "m" && code) {
            const { selectionStart, selectionEnd } = textAreaRef.current;
            if (selectionStart === selectionEnd) {
                // Only insert a tab when no text is selected
                textAreaRef.current.value = [
                    textAreaRef.current.value.slice(0, selectionStart),
                    "\t",
                    textAreaRef.current.value.slice(selectionStart),
                ].join("");
                event.preventDefault();
            }
        }
    }
    return (_jsxs("div", { className: style["text-area"], children: [_jsx("div", { className: classNames(style["text-area-container"], errorClass, codeClass), children: _jsx("textarea", Object.assign({}, textAreaProps, { onKeyDown: keyDownUpdate, ref: textAreaRef })) }), _jsxs("div", { className: classNames(style["text-area__code-help"], codeHelpClass), children: ["To insert a tab use ", _jsx("span", { children: "Control + M" }), "."] })] }));
}
